import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  constructor(
    private http: HttpClient, 
    private environmentService: EnvironmentService
  ) { }

  getFeatureFlagStateSummary() {
    const url = this.environmentService.getApiRoot() + 'feature-flag-state/summary';

    return this.http.get(url);
  }
  getFeatureFlagStateDetails() {
    const url = this.environmentService.getApiRoot() + 'feature-flag-state/details';

    return this.http.get(url);
  }
}
